import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { LinkButton } from '../../../../common/html/button/LinkButton'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { NotPermissionAccess } from '../../../../common/notPermissionAccess/NotPermissionAccess'
import { Pagination } from '../../../../common/pagination'
import { ScrollComponent } from '../../../../common/scrollComponent'
import { Tooltip } from '../../../../common/tooltip'
import { formatVal } from '../../../../helpers/value'
import { COMPONENTS } from '../../../../routers/constants'
import { CHECKBOX_KEYS } from '../constants'
import classes from '../index.module.scss'
import {
  changePage,
  changePageSize,
  selectCheckedOptions,
  selectData,
  selectLoading,
  selectPage,
  selectPageSize,
  selectTotalRecords,
} from '../store/slice'
import { postDomesticSearch } from '../store/thunk'
import { SearchResultItem } from './SearchResultItem'

export const SearchResults = ({ textSearch }) => {
  const dispatch = useDispatch()

  // Use selector
  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectData)
  const loading = useSelector(selectLoading)
  const totalRecords = useSelector(selectTotalRecords)
  const page = useSelector(selectPage)
  const pageSize = useSelector(selectPageSize)
  const checkedOptions = useSelector(selectCheckedOptions)

  // Actions
  const setPageSize = (value) => {
    dispatch(changePageSize(value))
  }

  const setPage = (value) => {
    dispatch(changePage(value))
  }

  // Use effect
  useEffect(() => {
    if (textSearch === undefined) return

    const statusIds = Object.keys(checkedOptions)
      .filter(
        (key) => key.includes(CHECKBOX_KEYS.STATUS) && checkedOptions[key],
      )
      .map((key) => +key.split('-')[1])
    const legalFormIds = Object.keys(checkedOptions)
      .filter(
        (key) => key.includes(CHECKBOX_KEYS.LEGAL_FORM) && checkedOptions[key],
      )
      .map((key) => +key.split('-')[1])
    const headQuarters = Object.keys(checkedOptions)
      .filter(
        (key) =>
          key.includes(CHECKBOX_KEYS.LOCATION_TYPE) && checkedOptions[key],
      )
      .map((key) => +key.split('-')[1])

    dispatch(
      postDomesticSearch({
        term: textSearch,
        statusIds: statusIds.length ? statusIds : undefined,
        legalFormIds: legalFormIds.length ? legalFormIds : undefined,
        headQuarters: headQuarters.length ? headQuarters : undefined,
        page,
        pageSize,
      }),
    )
  }, [textSearch, checkedOptions, page, pageSize, locale])

  // Render
  const renderTotalResult = () => {
    return (
      <Element elementName="div" style={{ color: '#3A414B' }}>
        <span className="fw600">
          {formatVal(totalRecords, locale, false, 0)}&nbsp;
          <Translate
            value={
              totalRecords < 2
                ? 'domesticSearch.RESULT'
                : 'domesticSearch.RESULTS'
            }
          />
        </span>
        &nbsp;
        <Translate value="domesticSearch.FOR_COMPANY" />: {textSearch}
      </Element>
    )
  }

  const renderTopComponent = () => {
    return (
      <div className="dFlex justifyContentBetween alignItemsCenter pb2">
        {renderTotalResult()}
        <div className="dFlex">
          <Translate value="domesticSearch.CANT_FIND_BUSINESS" />
          &nbsp;
          <LinkButton
            label="domesticSearch.TRY_SCREENING"
            style={{ fontSize: 12, color: '#2C73E8' }}
            route={COMPONENTS.screening.route}
            isI18n
          />
        </div>
      </div>
    )
  }

  const renderBottomComponent = () => {
    return (
      <Pagination
        page={page}
        pageSize={pageSize}
        total={totalRecords}
        setPageSize={setPageSize}
        setPage={setPage}
        className="pt2"
        isShowLastButton={false}
        pageSizeOptions={[
          { label: 10, value: 10 },
          { label: 20, value: 20 },
          { label: 50, value: 50 },
        ]}
      />
    )
  }

  const renderTooltipContent = () => {
    return <NotPermissionAccess />
  }

  return (
    <div className="positionRelative h100">
      {loading && <Loading />}
      {!loading && (
        <div className="flexColumn h100">
          {renderTopComponent()}
          <div className={[classes.searchResults, 'flex1'].join(' ')}>
            <ScrollComponent>
              {data.map((item, index) =>
                item.viewAllowed ? (
                  <SearchResultItem key={index} data={item} />
                ) : (
                  <Tooltip
                    key={index}
                    contentClass="w100"
                    tooltipContent={renderTooltipContent()}
                    isInsideContent
                  >
                    <SearchResultItem data={item} />
                  </Tooltip>
                ),
              )}
            </ScrollComponent>
          </div>
          {renderBottomComponent()}
        </div>
      )}
    </div>
  )
}
